"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _menu = _interopRequireDefault(require("antd/lib/menu"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _dashboard = require("../../redux/dashboard/dashboard.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _user = require("../../redux/user/user.selectors");

var _AntdIcon = _interopRequireDefault(require("../antdIcon/AntdIcon"));

var _SideBar = _interopRequireDefault(require("./SideBar"));

require("./sidebar.scss");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  SubMenu
} = _menu.default;

class StudySideBar extends _react.Component {
  componentDidMount() {
    this.props.loadDashboardData();
  }

  render() {
    const {
      study,
      collapsed,
      currentPath,
      isNonYAB,
      hasDataAnalystRole,
      hasStudyManagerRole,
      showTestkits,
      showIncentives,
      showSurveys,
      showForms,
      showGoals
    } = this.props;
    const studyId = currentPath.replace(/^\/study\/(\d+)\/?.*$/, '$1');
    const selectedKey = currentPath.replace(/^\/study\/\d+\/?(.*)$/, '/study/$1');
    const menuItems = [];

    if (isNonYAB) {
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faTachometerAltFastest
      }), /*#__PURE__*/_react.default.createElement("span", null, "Dashboard"))));
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/study",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/study`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faMicroscope
      }), /*#__PURE__*/_react.default.createElement("span", null, "Study"))));
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/participants",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/participants`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faUsers
      }), /*#__PURE__*/_react.default.createElement("span", null, "Participants"))));
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/inbox",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/inbox`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faInbox
      }), /*#__PURE__*/_react.default.createElement("span", null, "Inbox (", this.props.dashboardData.inbox.unreadThreads, ")"))));
    }

    menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "/study/forums",
      className: "sidebar-menu-item"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: `/study/${studyId}/forums`
    }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proSolidSvgIcons.faCommentsAlt
    }), /*#__PURE__*/_react.default.createElement("span", null, "Forums"))));

    if (isNonYAB) {
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/activities",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/activities`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faGamepadAlt
      }), /*#__PURE__*/_react.default.createElement("span", null, "Activities"))));
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/resources",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/resources`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faBooks
      }), /*#__PURE__*/_react.default.createElement("span", null, "Resources"))));

      if (showTestkits) {
        menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "/study/testkits",
          className: "sidebar-menu-item"
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: `/study/${studyId}/testkits`
        }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faVial
        }), /*#__PURE__*/_react.default.createElement("span", null, "Test Kits"))));
      }

      if (showIncentives) {
        menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "/study/payments",
          className: "sidebar-menu-item"
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: `/study/${studyId}/payments`
        }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faMoneyBillAlt
        }), /*#__PURE__*/_react.default.createElement("span", null, "Incentives"))));
      }

      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/qna",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/qna`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faBookMedical
      }), /*#__PURE__*/_react.default.createElement("span", null, "Ask an Expert (", this.props.dashboardData.qnas.unansweredCount, ")"))));
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/announcements",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/announcements`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faMegaphone
      }), /*#__PURE__*/_react.default.createElement("span", null, "Announcements"))));
      menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/appointments",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/appointments`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proLightSvgIcons.faCalendarAlt
      }), /*#__PURE__*/_react.default.createElement("span", null, "Appointments"))));

      if (showGoals) {
        menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "/study/goals",
          className: "sidebar-menu-item"
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: `/study/${studyId}/goals`
        }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faBullseyeArrow
        }), /*#__PURE__*/_react.default.createElement("span", null, "Goals"))));
      }
    }

    if (isNonYAB) {
      if (showSurveys) {
        menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "/study/surveys",
          className: "sidebar-menu-item"
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: `/study/${studyId}/surveys`
        }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faTasks
        }), /*#__PURE__*/_react.default.createElement("span", null, "Surveys"))));
      }

      if (showForms) {
        menuItems.push( /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "/study/form",
          className: "sidebar-menu-item"
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: `/study/${studyId}/form`
        }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faFileSignature
        }), /*#__PURE__*/_react.default.createElement("span", null, "Forms"))));
      }
    }

    if (hasDataAnalystRole) {
      menuItems.push( /*#__PURE__*/_react.default.createElement(SubMenu, {
        key: "/study/analytics",
        className: "sidebar-menu-item",
        title: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faDatabase
        }), /*#__PURE__*/_react.default.createElement("span", null, "Data Analytics"))
      }, showIncentives && /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/reports/incentives",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/reports/incentives`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faDollarSign
      }), /*#__PURE__*/_react.default.createElement("span", null, " Incentives"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/adHocQuery",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/adHocQuery`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faFileChartLine
      }), /*#__PURE__*/_react.default.createElement("span", null, " Ad Hoc Query Page")))));
    }

    if (isNonYAB) {
      menuItems.push( /*#__PURE__*/_react.default.createElement(SubMenu, {
        key: "/study/configuration",
        className: "sidebar-menu-item",
        title: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faCogs
        }), /*#__PURE__*/_react.default.createElement("span", null, "Configuration"))
      }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/avatars",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/avatars`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faUser
      }), /*#__PURE__*/_react.default.createElement("span", null, "Avatars"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/badges",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/badges`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faCertificate
      }), /*#__PURE__*/_react.default.createElement("span", null, "Badges"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/settings",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/settings`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faCog
      }), /*#__PURE__*/_react.default.createElement("span", null, "Settings"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/1/user",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/user`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faUserPlus
      }), /*#__PURE__*/_react.default.createElement("span", null, "User Creation"))), hasStudyManagerRole && /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/admin",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/admin`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faUsersCog
      }), /*#__PURE__*/_react.default.createElement("span", null, "Admin Management")))));
    } else {
      menuItems.push( /*#__PURE__*/_react.default.createElement(SubMenu, {
        key: "/study/configuration",
        className: "sidebar-menu-item",
        title: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faCogs
        }), /*#__PURE__*/_react.default.createElement("span", null, "Configuration"))
      }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "/study/settings",
        className: "sidebar-menu-item"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/settings`
      }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faCog
      }), /*#__PURE__*/_react.default.createElement("span", null, "Settings")))));
    }

    return /*#__PURE__*/_react.default.createElement(_SideBar.default, {
      collapsed: collapsed
    }, /*#__PURE__*/_react.default.createElement(_menu.default, {
      id: "sidebar-menu",
      selectedKeys: [selectedKey],
      mode: "inline",
      defaultSelectedKeys: ['/home']
    }, menuItems));
  }

}

const mapStateToProps = state => {
  const {
    pathname
  } = state.router.location;
  const {
    sidebar
  } = state.ui;
  return {
    study: selectors.getRequestedStudy(state),
    collapsed: sidebar.collapsed,
    currentPath: pathname,
    isNonYAB: (0, _user.isNonYAB)(state),
    hasDataAnalystRole: (0, selectors.hasDataAnalystRole)(state),
    hasStudyManagerRole: (0, selectors.hasStudyManagerRole)(state),
    dashboardData: selectors.selectDashboard(state),
    showTestkits: selectors.getTestKitsFeatureEnabled(state),
    showIncentives: selectors.getIncentivesFeatureEnabled(state),
    showGoals: selectors.getGoalSettingFeatureEnabled(state),
    showSurveys: selectors.getSurveysFeatureEnabled(state),
    showForms: selectors.getFormsFeatureEnabled(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadDashboardData: () => dispatch(_dashboard.loadDashboardDataAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StudySideBar);

exports.default = _default;